module.exports = __webpack_public_path__ + "static/img/helh423.7823f87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/healthycockpit/helh423.png
// module id = dxIe
// module chunks = 5